module.exports = __webpack_public_path__ + "static/media/Decisions_Step5_Image0.7f815894.jpg";